import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { generateUUID } from '../utils/uuid';
import { environment } from '../../../environments/environment';
import {first} from "rxjs";
import {SelectedWorkspaceStore} from "../../stores/selected-workspace.store";
import { UserJourneyEvent, TrackModel, InternalTrackModel } from './user-journey.types';
import * as Sentry from '@sentry/angular';
import { PdfExportContextService } from './pdf-export-context.service';
import { GaAnalyticsService } from './ga-analytics.service';
import { bindGTrackToMetricService } from '../../tracker';

@Injectable({
  providedIn: 'root',
})
export class MetricService {
  private baseUrl = environment.apiUrl;
  private sessionId: string;
  private pdfContext = inject(PdfExportContextService);
  private gaAnalytics = inject(GaAnalyticsService);

  constructor(private http: HttpClient, private selectedWorkspaceStore: SelectedWorkspaceStore) {
    let sessionId = sessionStorage.getItem('user_journey_session_id');
    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem('user_journey_session_id', sessionId);
    }
    this.sessionId = sessionId;
    bindGTrackToMetricService(this);
  }

  track(trackBody: TrackModel) {
    // Skip tracking in data-only mode (PDF export without backend calls)
    if (this.pdfContext.isDataOnlyMode) {
      return;
    }

    // Добавляем "хлебную крошку" в Sentry для контекстуализации ошибок.
    Sentry.addBreadcrumb({
      category: 'user-journey',
      message: trackBody.name,
      level: 'info',
      data: {
        ...trackBody.payload,
        elementText: trackBody.elementText,
        elementValue: trackBody.elementValue,
      },
    });

    const internalTrack: InternalTrackModel = {...trackBody, sessionId: this.sessionId};
    this.http.post(`${this.baseUrl}/api/metric`, internalTrack).pipe(first()).subscribe();

    this.gaAnalytics.trackEventName(trackBody.name);
  }
}
